<template>
  <v-row align-content="stretch" class="ma-n2">
    <v-col
      v-for="quote in quotes"
      :key="quote.id"
      class="pa-2"
      align-self="stretch"
      :cols="cols"
      :lg="lg"
      :md="md"
      :sm="sm"
      :xl="xl"
    >
      <quote-summary-card
        :is-lowest-price="quote.id === lowestMatchedQuoteId"
        :order="order"
        :quote="quote"
        :show-actions="showActions"
        @click="$emit('select', $event)"
        @update:order="$emit('update:order', $event)"
      />
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import QuoteSummaryCard from '@/components/quotes/quote-summary-card.vue'
import type { Order, Quote } from '@quotetome/materials-api'

export interface Props {
  quotes?: Quote[]
  order: Order
  cols?: number
  lg?: number
  md?: number
  sm?: number
  xl?: number
  showActions?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  quotes: () => [],
  cols: 12,
  lg: 4,
  md: 6,
  sm: 6,
  xl: 3,
})

defineEmits(['select', 'update:order'])

const fullyMatchedQuotes = computed(() =>
  props.quotes.filter(quote =>
    quote.response_received === 'price given'
    && quote.total_price != null
    && props.order.skus.every(orderSku =>
      quote.skus.some(quoteSku => quoteSku.reference_identifier === orderSku.internal_identifier)
    )
  )
)

const priceGivenCount = computed(() =>
  props.quotes.filter(q => q.response_received === 'price given').length
)

const lowestMatchedQuoteId = computed(() => {
  if (priceGivenCount.value < 2) return null
  if (!fullyMatchedQuotes.value.length || fullyMatchedQuotes.value.length !== priceGivenCount.value) return null
  return fullyMatchedQuotes.value.reduce((min, q) =>
    Number(q.total_price) < Number(min.total_price) ? q : min
  ).id
})
</script>
